import React, { useContext } from 'react'
import loadable from '@loadable/component'

import { MenuContext } from './index'

const LoanApplicationProgressBar = loadable(() => import('krea-direct/components/progress-bar'))

const HeaderSteps = () => {
	const context = useContext(MenuContext)

	return <LoanApplicationProgressBar isOpen={context.stepsIsVisible} hideStepsMenu={context.showSteps} />
}

export default HeaderSteps
